import * as React from "react";

function Astronaut(props) {
  return (
    <svg
      id="prefix__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 425 325"
      xmlSpace="preserve"
      {...props}
    >
      <style>
        {
          ".prefix__st1{fill:#000001}.prefix__st7{fill:#515151}.prefix__st12{fill:#bcbcbc}.prefix__st16{fill:none}"
        }
      </style>
      <g id="prefix__Group_11_1_" transform="rotate(-88 198.375 435.966)">
        <linearGradient
          id="prefix__Path_5_2_"
          gradientUnits="userSpaceOnUse"
          x1={-225.747}
          y1={72.076}
          x2={-236.183}
          y2={75.117}
          gradientTransform="matrix(-39.6832 -.8631 1.2824 -28.7955 -8271.87 3249.538)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_5_1_"
          d="M454.7 583.8c4.8 4.5 14.4 13.5 24.1 20.9 5.1 3.8 8.4 4.2 11 3.5-.3.8-.9 1.4-1.6 1.9-10.2 4.5-27.4-5.6-31.4-11.3-4-5.7-19.1-18.8-19.5-23.8v-.2c5.7-5.1 13.2 5.1 17.4 9z"
          fill="url(#prefix__Path_5_2_)"
        />
        <path
          id="prefix__Path_6_1_"
          className="prefix__st1"
          d="M478.9 604.7c-9.8-7.4-19.3-16.4-24.1-20.9-4.2-3.9-11.8-14.1-17.4-9-.1-4.9 8.4-10.5 12.8-15.6.4-.4.7-.9 1.1-1.4 6.8 3.6 16.5 19.2 17.8 22 .7 1.6 2.5.4 4.1-1 2.7 7.7 7.7 17.3 13.3 22.4 3.7 3.3 3.9 5.6 3.3 7.1-2.5.7-5.8.3-10.9-3.6z"
        />
        <linearGradient
          id="prefix__Path_7_2_"
          gradientUnits="userSpaceOnUse"
          x1={-197.13}
          y1={-19.056}
          x2={-197.719}
          y2={-17.255}
          gradientTransform="matrix(-70.1443 -3.1217 2.1027 -96.6044 -9956.346 -576.89)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_7_1_"
          d="M452.9 358.2c-11.3-2.5-9.6-11.3-9.6-11.4 5.2-12.5 9.8-13.8 17.6-16.9 3-1.1 6.2-1.4 9.4-.8 7 2.3 8.7 6.7 11.5 11.4 3.7 6.2 13.3 36.7 14 37.7.4.6.4 1.4-.1 1.9 1.8 3 17.1 28.7 18.4 30.5 1.3 1.9 6 7.8 7.1 10.8 1.1 3 8.1 9.6 11.2 11.6s2.5 3.4 2.2 5.6 0 2.8 1.2 5.8c1.3 3-1.6 6.6-2.7 8.4s-2.8 3.3-3.7 3.2c-.9-.2-.2-2.7-.2-2.7-1 .5-2 1.1-3 1.7-.6.5-1.6 1.3-2.2.4s.1-2.6.1-2.6-1 .9-1.2-.6 3.2-4.9 3.2-4.9c-4.5 1.2-2.3-3.3-2.3-3.3s-4.3-4.9-5.6-6c-1.3-1-2.3-7.8-3.8-10.4s-9.7-10.7-17.3-17.4-17.7-20.7-17.7-20.7c-4.2 3.1-6.8-7.1-9.7-11.1-2.9-4.1-5.5-17.8-16.8-20.2z"
          fill="url(#prefix__Path_7_2_)"
        />
        <linearGradient
          id="prefix__Path_8_2_"
          gradientUnits="userSpaceOnUse"
          x1={-499.633}
          y1={92.68}
          x2={-514.81}
          y2={99.42}
          gradientTransform="matrix(-16.3522 -.5726 .5061 -18.0789 -6964.504 3630.115)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_8_1_"
          d="M487.4 345.3l-.7-21.4-10.2-2.4-10.8 10 21.7 13.8z"
          fill="url(#prefix__Path_8_2_)"
        />
        <g id="prefix__Group_9_1_" transform="translate(577.997 292.202)">
          <path
            id="prefix__Path_9_3_"
            className="prefix__st1"
            d="M-110.2 30c1.3-3.9.6-8.3-2-11.5 5.4-15.2 20.5-24.9 36.6-23.4 17.1 1.4 29.8 16.5 28.4 33.6-.1.8-.2 1.5-.3 2.3-2.4 14.5-13.6 25.9-28 28.7C-84.7 53-107 36.2-110.2 30z"
          />
          <linearGradient
            id="prefix__Path_9_1_"
            gradientUnits="userSpaceOnUse"
            x1={5974.005}
            y1={6444.889}
            x2={5949.822}
            y2={6444.889}
            gradientTransform="rotate(-78.849 -937.271 6900.86)"
          >
            <stop offset={0} stopColor="#12b9ff" stopOpacity={0.7} />
            <stop offset={0.211} stopColor="#12afff" stopOpacity={0.552} />
            <stop offset={0.578} stopColor="#12a4ff" stopOpacity={0.295} />
            <stop offset={1} stopColor="#12a1ff" stopOpacity={0} />
          </linearGradient>
          <path
            id="prefix__Path_9_2_"
            d="M-66.6-3.1c6.1 0 20.7 14.7 19.3 31.8-.1.8-.2 1.5-.3 2.3-2.4 14.5-13.6 25.9-28 28.7 0-.4 28.2-31.3 9-62.8z"
            fill="url(#prefix__Path_9_1_)"
          />
          <path
            id="prefix__Path_10_1_"
            d="M-75.6 59.7C-84.7 53-107 36.2-110.2 30c1.3-3.9.6-8.3-2-11.5 5.4-15.2 20.5-24.9 36.6-23.4 7.3.7 14.2 3.9 19.4 9l-25.3 23.6L-70 58.1c-1.8.7-3.7 1.2-5.6 1.6z"
            fill="#7c7c7c"
          />
          <linearGradient
            id="prefix__Path_11_2_"
            gradientUnits="userSpaceOnUse"
            x1={-772.9}
            y1={-57.507}
            x2={-771.597}
            y2={-57.507}
            gradientTransform="matrix(-44.3868 -1.5509 1.3742 -48.9759 -34345.207 -13554.129)"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={1} stopColor="#9f9d9e" />
          </linearGradient>
          <path
            id="prefix__Path_11_1_"
            d="M-71.3 54.6c-3 .9-6 1.4-9.1 1.5-10.5-7.9-27-20.8-29.8-26 0 0 2.5-5.8-2.4-12 3.8-16.5 20.1-28.2 37.5-26.4 8.1.7 15.6 4.5 21 10.6l-27.4 25.6 10.2 26.7z"
            fill="url(#prefix__Path_11_2_)"
          />
          <path
            id="prefix__Path_12_1_"
            className="prefix__st7"
            d="M-87.8 41.5c-.5 2.6 1.2 5.1 3.9 5.6.1 0 .2 0 .3.1 2.9.2 5.4-1.8 5.8-4.7.5-2.6-1.3-5.1-3.9-5.6-.1 0-.2 0-.3-.1-2.9-.2-5.4 1.8-5.8 4.7z"
          />
          <linearGradient
            id="prefix__Path_13_2_"
            gradientUnits="userSpaceOnUse"
            x1={-1632.442}
            y1={-1061.33}
            x2={-1631.17}
            y2={-1061.33}
            gradientTransform="matrix(-6.7385 -.2161 .2106 -6.882 -10825.71 1808.42)"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={1} stopColor="#9f9d9e" />
          </linearGradient>
          <path
            id="prefix__Path_13_1_"
            d="M-83.5 46.5c2.5.2 4.7-1.6 5.1-4.1.4-2.3-1.1-4.5-3.4-4.9h-.3c-2.5-.2-4.7 1.6-5.1 4.1-.4 2.3 1.1 4.5 3.4 4.9h.3z"
            fill="url(#prefix__Path_13_2_)"
          />
          <path
            id="prefix__Path_14_1_"
            d="M-112.3 18.6c5.4-15.2 20.5-24.9 36.6-23.4 7.3.7 14.2 3.9 19.4 9"
            fill="none"
            stroke="#bcbcbc"
            strokeWidth={0.061}
            strokeMiterlimit={10}
          />
          <g id="prefix__Group_6_1_" transform="translate(41.982 25.577)">
            <linearGradient
              id="prefix__Path_15_2_"
              gradientUnits="userSpaceOnUse"
              x1={-2476.244}
              y1={-1629.418}
              x2={-2474.926}
              y2={-1629.418}
              gradientTransform="matrix(-3.7324 -.1242 .1162 -3.9415 -9144.541 2713.436)"
            >
              <stop offset={0} stopColor="#fff" />
              <stop offset={1} stopColor="#9f9d9e" />
            </linearGradient>
            <path
              id="prefix__Path_15_1_"
              d="M-124.7-32c-.7-.2-3.2.9-3.3 1.8 0 .8.9 3.3 1.4 3.4.5.1 3.2-.1 3.5-.7s-.7-4.2-1.6-4.5z"
              fill="url(#prefix__Path_15_2_)"
            />
            <linearGradient
              id="prefix__Path_16_2_"
              gradientUnits="userSpaceOnUse"
              x1={-2471.379}
              y1={-1625.299}
              x2={-2470.057}
              y2={-1625.299}
              gradientTransform="matrix(-3.7406 -.1243 .1165 -3.9444 -9160.452 2716.618)"
            >
              <stop offset={0} stopColor="#fff" />
              <stop offset={1} stopColor="#9f9d9e" />
            </linearGradient>
            <path
              id="prefix__Path_16_1_"
              d="M-138.5-26.3c-.6-.2-3.2.9-3.3 1.8s.9 3.2 1.4 3.4c.5.1 3.2-.1 3.5-.7s-.8-4.3-1.6-4.5z"
              fill="url(#prefix__Path_16_2_)"
            />
            <path
              id="prefix__Path_17_1_"
              className="prefix__st12"
              d="M-127.8-30.6c.8-.8 1.9-1.3 3.1-1.4.6.2 1.3 2 1.5 3.3-1.1.5-2.2.6-3.3.6-.4-.1-1-1.5-1.3-2.5z"
            />
            <path
              id="prefix__Path_18_1_"
              className="prefix__st12"
              d="M-141.6-25c.8-.8 1.9-1.3 3.1-1.4.6.2 1.3 2 1.5 3.3-1 .4-2.2.6-3.3.5-.4 0-1-1.3-1.3-2.4z"
            />
          </g>
          <g id="prefix__Group_8_1_" transform="translate(20.662 23.845)">
            <g id="prefix__Group_7_1_">
              <path
                id="prefix__Path_19_1_"
                className="prefix__st7"
                d="M-107 4.3c-.4 2 .9 3.9 2.9 4.3h.3c2.2.2 4.1-1.4 4.4-3.6.4-2-1-3.9-2.9-4.3h-.2c-2.2-.1-4.1 1.5-4.5 3.6z"
              />
              <linearGradient
                id="prefix__Path_20_2_"
                gradientUnits="userSpaceOnUse"
                x1={-2032.077}
                y1={-1359.714}
                x2={-2030.805}
                y2={-1359.714}
                gradientTransform="matrix(-4.883 -.1566 .1526 -4.9853 -9784.488 2343.511)"
              >
                <stop offset={0} stopColor="#fff" />
                <stop offset={1} stopColor="#9f9d9e" />
              </linearGradient>
              <path
                id="prefix__Path_20_1_"
                d="M-103.6 8c1.8.1 3.4-1.2 3.7-3 .3-1.7-.8-3.3-2.5-3.6h-.2c-1.8-.1-3.4 1.2-3.7 3-.3 1.7.8 3.3 2.5 3.6h.2z"
                fill="url(#prefix__Path_20_2_)"
              />
              <path
                id="prefix__Path_21_1_"
                d="M-104.1 3.9l.7-.5-2.7-4.6-.7.5 2.7 4.6z"
                fill="#202729"
              />
            </g>
          </g>
          <linearGradient
            id="prefix__Path_22_2_"
            gradientUnits="userSpaceOnUse"
            x1={-595.63}
            y1={-137.523}
            x2={-595.727}
            y2={-137.141}
            gradientTransform="matrix(-31.2414 -.9008 .9868 -29.008 -26133.248 -6252.456)"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={1} stopColor="#9f9d9e" />
          </linearGradient>
          <path
            id="prefix__Path_22_1_"
            d="M-112.7 18.1V18c7.9 7.7 26.8 19.6 32.7 14.5l8.5 22.2c-3 .9-6 1.4-9.1 1.5-10.5-7.9-27-20.8-29.8-26 .2-.2 2.7-5.9-2.3-12.1z"
            fill="url(#prefix__Path_22_2_)"
          />
        </g>
        <path
          id="prefix__Path_23_1_"
          className="prefix__st16"
          d="M421.6 399.5c-1.8.7-3.6 1.5-5.3 2.4-5.8 3.2-11.1.1-15.4-1.8 6.5-1.2 13.2-1.4 19.7-.7.4 0 .6 0 1 .1z"
        />
        <path
          id="prefix__Path_24_1_"
          className="prefix__st16"
          d="M421.6 399.5c-1.8.7-3.6 1.5-5.3 2.4-5.8 3.2-11.1.1-15.4-1.8 6.5-1.2 13.2-1.4 19.7-.7.4 0 .6 0 1 .1z"
        />
        <linearGradient
          id="prefix__Path_25_2_"
          gradientUnits="userSpaceOnUse"
          x1={-104.945}
          y1={-27.96}
          x2={-106.392}
          y2={-27.72}
          gradientTransform="matrix(-134.4871 -6.2549 4.0038 -192.94 -13593.102 -5744.408)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_25_1_"
          d="M471.3 330.1c9.3 1.2 15.4 11.9 15.4 11.9l6.1 3.1-3 23.3-3.5 1.6-4.1 7.1-21.9 33c-1.3 0-2.5 1-2.7 2.3 2.1 1.6 3.6 2.7 3.6 2.7 4.8 3.2 4.4 7.4 4.4 7.4 1.4.4 2.3 1.9 2.1 3.3 4.2.4 5.3 3.3 5.3 3.3.4.2 1.6 2.6 2.5 3.5.1 0 .1.1.2.1 8.2 7 15.8 13.7 17.5 15.6 3.7 4 6.7 2.7 11.2 5.8 1.9 1.2 3.3 3.1 3.8 5.3 9 4.5 12.1 15 8.1 22.3-1 1.9-7.5 10.5-12 16.1-4.4 5.6-25.6 40.3-28.1 46.3s-5.5 24-3.4 32.7c.4 1.5.9 3.2 1.5 4.9-1.7 1.6-3.7 2.8-4.5 1.1-1.4-3-11.9-20-19.3-23.9 4.1-6.2 5.8-17.1 5.8-17.1s-7.3-3.3-7.8-4.1 2.8-10.7 4.9-14.3c2.1-3.6 13.6-26.6 14.5-31 1.4-6.1 3.6-12.1 6.5-17.6-.5-.4-1-.9-1.5-1.2-2.6 4-5.9 7.4-9.8 10-3.2 2-12.5-.8-16.4-2.3-3.9-1.6-6 1.1-7.9-1.7-1.9-2.9-8.3-.4-33.1.1-17.8.3-35.4 4.7-51.3 12.7-3.9 2-5.4 3.7-6.3 5.5-1.9-3.8-4.5-8.2-6.7-10.1-3.8-3.3 5.6-12.1 5-20 6.9.4 21.8-4.3 21.8-4.3s1.3-8 1.9-9.3c.6-1.3 2.8-1.5 11.5-1.6 4.6-.1 13.5-1.4 22-2.8-3.9-4.4-7.2-8.9-8.2-12.9-.2-.6-.4-1.1-.6-1.7-1.1-4-9.9-12.9-3.3-32 1.2-3.6 2.9-4.6 4.9-4.5 1.4-1.7 2.6-3.5 3.6-5.4 3.9-7.6 13.8-11.3 13.8-11.3-1.4-1.4 24-37.1 24-37.1.1-2.2 5.5-5.5 5.5-5.5 14-11.8 18.7-10.5 28-9.3z"
          fill="url(#prefix__Path_25_2_)"
        />
        <linearGradient
          id="prefix__Path_26_2_"
          gradientUnits="userSpaceOnUse"
          x1={-106.185}
          y1={75.999}
          x2={-105.84}
          y2={77.208}
          gradientTransform="matrix(-122.434 -.7319 4.1551 -33.5442 -12810.924 2836.049)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_26_1_"
          d="M474.3 376.6c9.7 4.9 38.7 12.2 56.5 9.6 0 0 9 1.3 9.8-2.7 4 .1 7.9-.5 11.7-1.6 6.1-1.9 34.3-14.5 39.2-16.6s9.6-2.1 13.1-4.4c3.5-2.3 7.3-3.6 10.3-1.4 0 0 2.8.2 1.2-1.8.6-.2 1.3-.1 1.8.4.6.8 1.9-.4 1-2.4s-1.6-6.5-6.6-8c1.3-.4 2.6-.2 3.8.5 1.7 1.1 3 .7 3.3 0 .3-.7-.8-2.2-2.5-2.9-1.7-.7-4.7-2.8-8.7-1.5-3.9 1.3-9.4 1.8-11.9 5.2-2.5 3.4-4.8 5.3-6.6 5.8-1.8.5-14.8 4.4-24.2 6.6-9.4 2.2-19.6 3.5-22.4 5.4 0 0-.4-.9-4.1-.8-3.7 0-5-1.7-7.8 0 0 0-12.1-2.2-17.4-1.4 0 0-5.4-2.9-8.8-2.8-3.4.1-10.9-7-13.6-8.9-2.7-1.9-19.3-21.5-30.5-.5-11.4 20.9 13.4 24.2 13.4 24.2z"
          fill="url(#prefix__Path_26_2_)"
        />
        <g id="prefix__Group_10_1_" transform="translate(440.793 430.293)">
          <path
            id="prefix__Path_27_1_"
            className="prefix__st1"
            d="M-97.9 56.8c2.2 1.9 4.6 6.1 6.5 9.8-1.1 2.1-1.4 4.1-4.3 6.4-5.2 4.1-5.2 15.9-4.8 21.2.3 5.2-1.1 8.4-5 8.9 2.4-.8-3.9-15-5.2-24.5-1.2-9-2.3-36-4.9-45.2 3-2.1 15.4 2.1 20.7 3.8.6.2 1.2.3 1.8.3.6 7.5-8.6 16.1-4.8 19.3z"
          />
          <linearGradient
            id="prefix__Path_28_2_"
            gradientUnits="userSpaceOnUse"
            x1={-1956.134}
            y1={-691.512}
            x2={-1962.13}
            y2={-678.038}
            gradientTransform="matrix(-9.4642 -1.8144 .1405 -52.9308 -11252.19 -22143.885)"
          >
            <stop offset={0} stopColor="#fff" />
            <stop offset={1} stopColor="#9f9d9e" />
          </linearGradient>
          <path
            id="prefix__Path_28_1_"
            d="M-105.5 103c-12.3 1.5-12.6-21.8-11.4-28 1.3-6.3.5-17.5-.2-21.3-.6-3.8-1.4-18 1.3-20.3l.1-.1c2.6 9.2 3.7 36.2 4.9 45.2 1.4 9.5 7.8 23.7 5.3 24.5z"
            fill="url(#prefix__Path_28_2_)"
          />
        </g>
        <linearGradient
          id="prefix__Path_29_2_"
          gradientUnits="userSpaceOnUse"
          x1={-141.849}
          y1={-10.176}
          x2={-145.151}
          y2={-9.757}
          gradientTransform="matrix(-77.2561 -2.6765 2.3942 -84.5872 -10397.482 50.919)"
        >
          <stop offset={0} stopColor="#fff" />
          <stop offset={1} stopColor="#9f9d9e" />
        </linearGradient>
        <path
          id="prefix__Path_29_1_"
          d="M403.8 413.9c-10.1-6.9-41.2-17.6-23.6-30.2s7.2-19.6 17.4-34.6 25.3-47 40.5-46.8c15.3.1 42.1 16.6 38.1 34.7s-72.4 76.9-72.4 76.9z"
          fill="url(#prefix__Path_29_2_)"
        />
      </g>
    </svg>
  );
}

export default Astronaut;
